import Vue from 'vue';
import VueRecaptcha from 'vue-recaptcha';

Vue.use(VueRecaptcha, {});
